import ACTIONS from '../actionTypes/diagnostic'

const initialState = {
  exceptionLogsList: [],
  exceptionLogsTotalCount: 0,
  isFetchingExceptionLogs: false,
  errorFetchingExceptionLogs: false,
  allExceptionTypes: [],
  isFetchingAllExceptionTypes: false,
  errorFetchingAllExceptionTypes: false,
}

const diagnostic = (state = initialState, action) => {
  switch (action.type) {
    // getExceptionLogsList
    case ACTIONS.START_GET_EXCEPTION_LOGS:
      return {
        ...state,
        isFetchingExceptionLogs: true,
      }
    case ACTIONS.GET_EXCEPTION_LOGS_SUCCESS:
      return {
        ...state,
        exceptionLogsList: action.append ? [...state.exceptionLogsList, ...action.payload?.exceptionLogs] : action.payload?.exceptionLogs,
        exceptionLogsTotalCount: action.payload?.totalCount,
        isFetchingExceptionLogs: false,
        errorFetchingExceptionLogs: false
      }
    case ACTIONS.GET_EXCEPTION_LOGS_FAILED:
      return {
        ...state,
        isFetchingExceptionLogs: false,
        errorFetchingExceptionLogs: true
      }

    // getAllExceptionTypes
    case ACTIONS.START_GET_ALL_EXCEPTION_TYPES:
      return {
        ...state,
        isFetchingAllExceptionTypes: true,
      }
    case ACTIONS.GET_ALL_EXCEPTION_TYPES_SUCCESS:
      return {
        ...state,
        allExceptionTypes: action.payload,
        isFetchingAllExceptionTypes: false,
        errorFetchingAllExceptionTypes: false
      }
    case ACTIONS.GET_ALL_EXCEPTION_TYPES_FAILED:
      return {
        ...state,
        isFetchingAllExceptionTypes: false,
        errorFetchingAllExceptionTypes: true
      }

    // default
    default:
      return state
  }
}

export default diagnostic